"use client";

interface CapabilityIconsProps {
  useSharedWorkspace?: boolean;
  chatAttachmentsEnabled?: boolean;
  authEnabled?: boolean;
  // undefined or true means history is on; only an explicit false renders the struck clock
  historyEnabled?: boolean;
  toolsCount?: number;
  size?: number;
}

// Monochrome capability glyphs for an agent card. Each maps to a real backend flag;
// nothing is shown for a capability the agent does not declare.
export function CapabilityIcons({
  useSharedWorkspace,
  chatAttachmentsEnabled,
  authEnabled,
  historyEnabled,
  toolsCount,
  size = 12,
}: CapabilityIconsProps) {
  const showHistoryOff = historyEnabled === false;
  const hasTools = typeof toolsCount === "number" && toolsCount > 0;

  if (
    !useSharedWorkspace &&
    !chatAttachmentsEnabled &&
    !authEnabled &&
    !showHistoryOff &&
    !hasTools
  ) {
    return null;
  }

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        color: "var(--fg-quaternary)",
        flexShrink: 0,
      }}
    >
      {useSharedWorkspace && (
        <span title="Shared workspace" style={{ display: "inline-flex" }}>
          <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <rect x="2" y="3" width="12" height="10" rx="1" />
            <path d="M2 6h12" />
          </svg>
        </span>
      )}
      {chatAttachmentsEnabled && (
        <span title="Attachments enabled" style={{ display: "inline-flex" }}>
          <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <path d="M11 5.5l-5 5a2.1 2.1 0 0 0 3 3l5.5-5.5a3.5 3.5 0 0 0-5-5L4 8.5" />
          </svg>
        </span>
      )}
      {authEnabled && (
        <span
          title="User authentication required"
          style={{ display: "inline-flex" }}
        >
          <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <rect x="3" y="7" width="10" height="7" rx="1" />
            <path d="M5 7V5a3 3 0 0 1 6 0v2" />
          </svg>
        </span>
      )}
      {showHistoryOff && (
        <span
          title="History disabled"
          style={{ display: "inline-flex", color: "var(--fg-tertiary)" }}
        >
          <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <circle cx="8" cy="8" r="6" />
            <path d="M8 4v4l2.5 1.5" />
            <path d="M3 3l10 10" />
          </svg>
        </span>
      )}
      {hasTools && (
        <span
          className="mono"
          style={{ fontSize: 10.5, color: "var(--fg-tertiary)" }}
        >
          {toolsCount}t
        </span>
      )}
    </div>
  );
}
